<script>
	import RadioGroup from "./RadioGroup.svelte";

	export let name;
	export let label;
	export let sublabel;
	export let value;

	export let required;
	export let disabled = null;

	const yesNoOptions = [
		{ label: "Yes", value: "Yes" },
		{ label: "No", value: "No" }
	];
</script>

<RadioGroup
	{disabled}
	{required}
	{name}
	{label}
	{sublabel}
	bind:value
	optionList={yesNoOptions}
	labelProperty="label"
	valueProperty="value"></RadioGroup>
